import { Account, Transaction } from "@multiversx/sdk-core";
import elrondHelper from "@/helpers/elrond";
import BLOCKCHAIN from "@/constants/blockchain";
import BaseContract from "@/contracts/baseContract";
import { BigUIntValue, ContractFunction, TokenTransfer, U64Value } from "@multiversx/sdk-core/out";
import { BigNumber } from "bignumber.js";

export const MEME_AUCTION_CONSTANTS = {
  ERRORS: {
    CANT_UPGRADE: "Nft can't be upgraded",
  },
};

export const MEME_AUCTION_FUNCTIONS = {
  UPGRADE_TOKEN: "upgrade_token",
  CLAIM_REWARDS: "claim_rewards",
};

class MemeAuctionContract extends BaseContract {
  constructor() {
    super(BLOCKCHAIN.MEMES_AUCTION_CONTRACT, "memes-auction", "MemesAuction");
  }

  // Endpoints
  async upgradeToken(account: Account, nonce: number, isTopMeme: boolean): Promise<Transaction> {
    await this.getContractAbi();

    const interaction = this.contract.methods[MEME_AUCTION_FUNCTIONS.UPGRADE_TOKEN]([]).withGasLimit(10_000_000);

    if (isTopMeme) {
      interaction.withSingleESDTTransfer(TokenTransfer.nonFungible(BLOCKCHAIN.TOP_MEME_NFT_TOKEN_IDENTIFIER, nonce));
    } else {
      interaction.withSingleESDTTransfer(TokenTransfer.nonFungible(BLOCKCHAIN.MEME_NFT_TOKEN_IDENTIFIER, nonce));
    }

    return await elrondHelper.buildAndSendInteraction(interaction, account);
  }

  async claimRewards(account: Account, nonce: number, isTopMeme: boolean): Promise<Transaction> {
    await this.getContractAbi();

    const interaction = this.contract.methods[MEME_AUCTION_FUNCTIONS.CLAIM_REWARDS]([]).withGasLimit(5_000_000);

    if (isTopMeme) {
      interaction.withSingleESDTTransfer(TokenTransfer.nonFungible(BLOCKCHAIN.TOP_MEME_NFT_TOKEN_IDENTIFIER, nonce));
    } else {
      interaction.withSingleESDTTransfer(TokenTransfer.nonFungible(BLOCKCHAIN.MEME_NFT_TOKEN_IDENTIFIER, nonce));
    }

    return await elrondHelper.buildAndSendInteraction(interaction, account);
  }

  // Views
  async getNutsForMeme(nonce: number): Promise<BigNumber> {
    await this.getContractAbi();

    const query = this.contract.createQuery({
      func: new ContractFunction("nuts_for_meme"),
      args: [new U64Value(nonce)],
    });

    const result = await elrondHelper.cachedProxy.queryContract(query);

    const endpointDefinition = this.contract.getEndpoint("nuts_for_meme");
    const { firstValue } = this.resultParser.parseQueryResponse(result, endpointDefinition);

    return (firstValue as BigUIntValue).valueOf();
  }

  async memeRarity(nonce: number): Promise<number> {
    const result = await this.queryView("meme_rarity", [new U64Value(nonce)]);

    return result.valueOf().toNumber();
  }

  async memeToTopMeme(nonce: number): Promise<number> {
    const result = await this.queryView("meme_to_top_meme", [new U64Value(nonce)]);

    return result.valueOf().toNumber();
  }
}

const memeAuctionContract = new MemeAuctionContract();

export default memeAuctionContract;
